import React from 'react'

function NoMatch() {
  return (
    <div>There's nothing here: 404!</div>
  )
}

export default NoMatch